// extracted by mini-css-extract-plugin
export var bold = "_sr-0";